/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import filter from 'lodash/filter'
import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_ROLES } from '../../actions.type'
import {
  CREATE_ROLE,
  REMOVE_ROLE,
  SET_ROLE_ALL_REQUEST,
  SET_ROLE_ALL_VALUE,
  UPDATE_ROLE
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  roleAllValue: (state) => filter(state.all.value, (val) => !val.isSuper),
  roleAllRequest: (state) => state.all.request,
  roleAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_ROLES]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('role', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_ROLE_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_ROLE_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_ROLE_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_ROLE_ALL_VALUE, data)
    } catch (e) {
      commit(SET_ROLE_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_ROLE({ commit }, value) {
    commit(CREATE_ROLE, value)
  },

  async SOCKET_UPDATE_ROLE({ commit }, value) {
    commit(UPDATE_ROLE, value)
  },

  async SOCKET_REMOVE_ROLE({ commit }, id) {
    commit(REMOVE_ROLE, id)
  }
}

const mutations = {
  [SET_ROLE_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_ROLE_ALL_VALUE](state, roles) {
    state.all.value = roles
  },
  [UPDATE_ROLE](state, updatedRole) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedRole.id }),
      1,
      updatedRole
    )
  },
  [CREATE_ROLE](state, createdRole) {
    state.all.value.push(createdRole)
  },
  [REMOVE_ROLE](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
